import type { SVGProps } from "react";

export const PlayCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className="fill-current"
    >
      <path
        d="M19.2 12C19.2 8.02356 15.9764 4.80001 12 4.80001C8.0235 4.80001 4.79995 8.02356 4.79995 12C4.79995 15.9765 8.0235 19.2 12 19.2C15.9764 19.2 19.2 15.9765 19.2 12ZM20.8 12C20.8 16.8601 16.8601 20.8 12 20.8C7.13985 20.8 3.19995 16.8601 3.19995 12C3.19995 7.13991 7.13985 3.20001 12 3.20001C16.8601 3.20001 20.8 7.13991 20.8 12Z"
        fill="currentColor"
      />
      <path
        d="M9.99995 15.6L15.6 12L9.99995 8.40001V15.6Z"
        fill="currentColor"
      />
    </svg>
  );
};
